// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

export class Controller {
    /** @ngInject */
    constructor(ApprovalFormsService, ConfirmDeleteModal, $state, ShowNoteModal) {
        this.ApprovalFormsService = ApprovalFormsService;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
        this.ShowNoteModal = ShowNoteModal;
    }

    $onInit() {
    }

    showDescription(approvalForm){
        this.ShowNoteModal('Description', approvalForm.description);
    }

    createNewApprovalForm() {
        this.isAdding = true;
        this.ApprovalFormsService.createNewApprovalForm(this.companyId)
            .then((data) => {
                this.$state.go('^.edit',{approvalFormId: data.id}, {reload: '^'});
            })
            .finally(() => this.isAdding = false);
    }

    removeApprovalForm(approvalForm) {
        this.ConfirmDeleteModal('Are you sure you want to delete this approval form')
            .then(() => {
                this.isRemoving = approvalForm;
                this.ApprovalFormsService.deleteApprovalForm(approvalForm.id, this.companyId)
                    .then(() => this.$state.reload('company.request-center'))
                    .finally(() => this.isRemoving = null);
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/list/approval-forms-list.controller.js